<mat-card class="altair-card starter-card mb-25 border-radius bg-white border-none d-block text-center">
    <mat-card-content>
        <ng-container *ngIf="!themeService.isDark()">
            <img src="assets/images/logo-intrust-para-fondo-claro.png" alt="starter-image">
        </ng-container>
        <ng-container *ngIf="themeService.isDark()">
            <img src="assets/images/logo-intrust-para-fondo-oscuro.png" alt="starter-image">
        </ng-container>
        <ng-container *transloco="let t">
            <h3>
                {{t('welcome')}} ALTAIR
            </h3>
            <a mat-button routerLink="/dashboard">
                {{t('getting-started')}}
            </a>
        </ng-container>
    </mat-card-content>
</mat-card>
